import { useEffect } from 'react';
import { BRAND } from '@/lib/brand';

type HeadProps = {
  heading: string;
  description?: string;
};

export const Head = ({ heading, description }: HeadProps) => {
  useEffect(() => {
    if (!heading) return;

    const previousTitle = document.title;
    // The /clu page on the Clu brand would read "Clu - Clu".
    document.title =
      heading === BRAND.dotName ? heading : `${heading} - ${BRAND.dotName}`;

    return () => {
      document.title = previousTitle;
    };
  }, [heading]);

  useEffect(() => {
    if (description === undefined) return;

    const existingMeta = document.head.querySelector<HTMLMetaElement>(
      'meta[name="description"]'
    );
    const meta = existingMeta ?? document.createElement('meta');
    const previousContent = meta.getAttribute('content');
    meta.name = 'description';
    meta.content = description;
    if (!existingMeta) document.head.appendChild(meta);

    return () => {
      if (!existingMeta) {
        meta.remove();
      } else if (previousContent === null) {
        meta.removeAttribute('content');
      } else {
        meta.content = previousContent;
      }
    };
  }, [description]);

  return null;
};
